import { inject, watch, toValue, type MaybeRefOrGetter } from 'vue'
import { useDialog } from './useDialog'

interface DialogRuntimeOptions {
  hideCloseButton?: MaybeRefOrGetter<boolean | undefined>
  preventOutsideClick?: MaybeRefOrGetter<boolean | undefined>
}

export function useDialogOptions(options: DialogRuntimeOptions) {
  const dialogId = inject<number | undefined>('dialogId', undefined)
  if (dialogId === undefined) return

  const { updateOptions } = useDialog()

  watch(
    () => ({
      hideCloseButton: toValue(options.hideCloseButton),
      preventOutsideClick: toValue(options.preventOutsideClick),
    }),
    (value) => updateOptions(value, dialogId),
    { immediate: true }
  )
}
